import React from "react";
import InputV2 from "@ui/Input/InputV2";

type InputV2Props = React.ComponentProps<typeof InputV2>;

interface SignedNumberInputProps extends Omit<InputV2Props, "onChange" | "type" | "value"> {
  defaultNegative?: boolean;
  onValueChange: (value: string) => void;
  value: string;
}

export function getSignedNumberInputValue(
  value: string,
  hasReceivedFirstValue: boolean,
): { value: string; hasReceivedFirstValue: boolean } {
  if (hasReceivedFirstValue || value === "") {
    return { value, hasReceivedFirstValue };
  }

  return {
    value: value.startsWith("-") || value === "0" ? value : `-${value}`,
    hasReceivedFirstValue: true,
  };
}

export function getSignedNumberInputError(value: string): string | null {
  return value === "" || !Number.isFinite(Number(value)) ? "invalid" : null;
}

const SignedNumberInput = ({
  defaultNegative = false,
  onValueChange,
  step = 1,
  value,
  ...props
}: SignedNumberInputProps) => {
  const [hasReceivedFirstValue, setHasReceivedFirstValue] = React.useState(
    () => !defaultNegative || (value !== "" && value !== "0"),
  );

  return (
    <InputV2
      {...props}
      type="number"
      value={value}
      step={step}
      onChange={e => {
        const nextValue = defaultNegative
          ? getSignedNumberInputValue(e.target.value, hasReceivedFirstValue)
          : { value: e.target.value, hasReceivedFirstValue: true };

        setHasReceivedFirstValue(nextValue.hasReceivedFirstValue);
        onValueChange(nextValue.value);
      }}
    />
  );
};

export default React.memo(SignedNumberInput);
